// Utility per ottenere l'URL API corretto
// In produzione (ristorantissimo.it o altri domini custom) usa URL relativo
// In development/preview usa la variabile d'ambiente

export const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // Se siamo su un dominio custom (non localhost e non preview)
    if (!hostname.includes('localhost') && 
        !hostname.includes('127.0.0.1') && 
        !hostname.includes('preview.emergentagent.com')) {
      return '/api';
    }
  }
  // Development/Preview: usa variabile d'ambiente
  return (process.env.REACT_APP_BACKEND_URL || '') + '/api';
};

export const API = getApiUrl();

export default API;
